<template>
	<BreaksConfirmation>
		<template #header>
			<h3 v-data-cy="'schedule-rest-break-header'">
				Schedule rest break
			</h3>
		</template>
		<template #bodyIcon>
			<OrigamiIcon
				name="schedule"
				width="32"
				height="32"
				class="tw-text-origami-grey-400"
			/>
		</template>
		<template #bodyText>
			<p
				v-data-cy="'start-time-body-text'"
				class="tw-text-left tw-mb-1 tw-text-xs"
			>
				Start time
			</p>
			<BreakRequestTimeDropdown
				:min-start-time="minStartTime"
				:max-start-time="maxStartTime"
				@select-time-block="handleSelectedTime"
			/>
		</template>
		<template #buttons>
			<OrigamiButton
				v-jest="'cancel-rest-break-button'"
				v-data-cy="'cancel-rest-break-button'"
				variant="secondary"
				class="tw-m-auto tw-mb-2 tw-w-full tw-justify-center"
				@click.native="cancelRestBreak"
			>
				Cancel
			</OrigamiButton>
			<OrigamiButton
				v-jest="'schedule-rest-break-button'"
				v-data-cy="'schedule-rest-break-button'"
				class="tw-mb-2 tw-w-full tw-justify-center"
				variant="primary"
				:is-loading="$store.state.BreaksManagementWidget.isRequestLoading"
				:disabled="!selectedTimeBlock"
				@click.native="requestRestBreak"
			>
				Schedule for later
			</OrigamiButton>
		</template>
	</BreaksConfirmation>
</template>

<script>
import { OrigamiButton, OrigamiIcon } from "@origami/vue2";

import BreakRequestTimeDropdown from "../elements/BreakRequestTimeDropdown.vue";
import BreaksConfirmation from "../templates/BreaksConfirmation.vue";

export default {
	components: {
		OrigamiButton,
		BreakRequestTimeDropdown,
		BreaksConfirmation,
		OrigamiIcon,
	},
	data() {
		return {
			selectedTimeBlock: null,
			minStartTime: null,
			maxStartTime: null,
		};
	},
	created() {
		const minMaxStartTime = this.$store.getters["TutorSchedule/getRestBreakMinMaxStartTime"];
		this.minStartTime = new Date(minMaxStartTime.min_start_time);
		this.maxStartTime = new Date(minMaxStartTime.max_start_time);
	},
	methods: {
		cancelRestBreak() {
			this.$store.dispatch("BreaksManagementWidget/resetWorkflow");
		},
		requestRestBreak() {
			this.$store.dispatch("BreaksManagementWidget/scheduleRestBreak", {
				scheduledStartTime: this.selectedTimeBlock,
			});
		},
		handleSelectedTime(selectedTime) {
			this.selectedTimeBlock = selectedTime;
		},
	},
};
</script>
